import { render, staticRenderFns } from "./imagenPasos.vue?vue&type=template&id=4f1735b0&scoped=true"
import script from "./imagenPasos.vue?vue&type=script&lang=js"
export * from "./imagenPasos.vue?vue&type=script&lang=js"
import style0 from "./imagenPasos.vue?vue&type=style&index=0&id=4f1735b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1735b0",
  null
  
)

export default component.exports